var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('com-content',{staticClass:"bookings"},[_c('iframe',{ref:"embed",staticClass:"bookings-embed",style:({height: _vm.height + 'px'}),attrs:{"src":_vm.page.business.bookings}})])}
var staticRenderFns = []

export { render, staticRenderFns }